import { EmployeeInput, ProcessEmployeeDocumentInput } from '@vivaldis/graphql'
import { StepProvider } from './provider/StepProvider'
import { AddWorkPermitStep } from './steps/AddWorkPermitStep'
import { ConfirmEditingStep } from './steps/ConfirmEditingStep'
import { EditManuallyStep } from './steps/EditManuallyStep'
import { EnterSSNStep } from './steps/EnterSSNStep'
import { OcrFailedStep } from './steps/OcrFailedStep'
import { OcrSucceededStep } from './steps/OcrSucceededStep'
import { UploadIDDocumentStep } from './steps/UploadIDDocumentStep'
import { CountryType } from './types/CountryType'
import { Employee } from './types/Employee'

interface Props {
  employee: Employee
  onEmployeeUpdate: (employeeInput: EmployeeInput) => Promise<void>
  onIDDocumentSubmit: (
    processEmployeeDocumentInput: ProcessEmployeeDocumentInput
  ) => Promise<Employee | undefined>
  onGoBack: () => void
  countries: CountryType[]
}

export const EditEmployeePersonalInformationForm = ({
  employee,
  onEmployeeUpdate,
  onGoBack,
  onIDDocumentSubmit,
  countries
}: Props) => {
  return (
    <StepProvider>
      <ConfirmEditingStep onCancel={onGoBack} />
      <UploadIDDocumentStep
        employee={employee}
        onIDDocumentSubmit={onIDDocumentSubmit}
      />
      <OcrFailedStep />
      <OcrSucceededStep
        countries={countries}
        employee={employee}
        onGoBack={onGoBack}
      />
      <EnterSSNStep
        countries={countries}
        employee={employee}
        onSubmit={onEmployeeUpdate}
        onGoBack={onGoBack}
      />
      <EditManuallyStep
        countries={countries}
        employee={employee}
        onSubmit={onEmployeeUpdate}
        onGoBack={onGoBack}
      />
      <AddWorkPermitStep onEmployeeUpdate={onEmployeeUpdate} />
    </StepProvider>
  )
}
